module.exports = __webpack_public_path__ + "static/media/KMH_5058.7a10cffe.jpg";